import { Controller } from "@hotwired/stimulus"

const MAX_ROWS = 6

export default class extends Controller {
  static values = { autofocus: Boolean }

  connect() {
    this.element.style.resize = "none"
    this.resize()
    if (this.autofocusValue) this.element.focus()
  }

  resize() {
    const el = this.element
    const style = getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight)
    const paddingTop = parseFloat(style.paddingTop)
    const paddingBottom = parseFloat(style.paddingBottom)
    const maxHeight = lineHeight * MAX_ROWS + paddingTop + paddingBottom

    el.style.height = "auto"
    el.style.height = Math.min(el.scrollHeight, maxHeight) + "px"
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden"
  }
}
